"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _emotionTheming = require("emotion-theming");

var s = _interopRequireWildcard(require("./NormalInput.style"));

var NormalInput =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(NormalInput, _Component);

  function NormalInput(props) {
    var _this;

    (0, _classCallCheck2.default)(this, NormalInput);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(NormalInput).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "showPasswordHandler", function () {
      _this.setState({
        showPassword: !_this.state.showPassword
      });
    });
    _this.state = {
      showPassword: false
    };
    return _this;
  }

  (0, _createClass2.default)(NormalInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          className = _this$props.className,
          textAlign = _this$props.textAlign,
          type = _this$props.type,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["theme", "className", "textAlign", "type"]);
      var showPassword = this.state.showPassword;

      if (type === 'password') {
        return _react.default.createElement("div", {
          className: s.passwordWrapper()
        }, _react.default.createElement("input", (0, _extends2.default)({
          className: (0, _classnames.default)(className, s.inputStyles(theme, textAlign, type === 'password')),
          type: showPassword ? 'text' : type
        }, other)), _react.default.createElement("span", {
          role: "presentation",
          onClick: this.showPasswordHandler,
          className: s.pwdText(theme)
        }, showPassword ? 'Hide' : 'Show'));
      }

      return _react.default.createElement("input", (0, _extends2.default)({
        className: (0, _classnames.default)(className, s.inputStyles(theme, textAlign)),
        type: type
      }, other));
    }
  }]);
  return NormalInput;
}(_react.Component);

NormalInput.propTypes = {
  className: _propTypes.default.string,
  textAlign: _propTypes.default.oneOf(['right', 'left'])
};
NormalInput.defaultProps = {
  className: '',
  textAlign: 'left'
};

var _default = (0, _emotionTheming.withTheme)(NormalInput);

exports.default = _default;